module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/barre_mx-039ebf7195a6758a6aafe31e2cfdc2f2.png";